export default "__VITE_ASSET__Bg1MmMoT__"